import { Cookies } from 'react-cookie';

import { CompleteVulnerabilityFormValues } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PatchCompleteEncounterProps {
  vulnerabilityId: number;
  vul: CompleteVulnerabilityFormValues;
  objectSlug: string;
}

export const patchCompleteEncounter = async ({ vulnerabilityId, vul, objectSlug }: PatchCompleteEncounterProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const fd = new FormData();
  fd.append('fix_date', vul.fix_date);
  fd.append('fix_comment', vul.fix_comment || '');
  if (Array.isArray(vul.photos) && vul.photos.length > 0) {
    vul.photos.forEach(file => {
      fd.append('photos', file);
    });
  }
  const data = await axiosInterceptor.patch(
    `/objects/${objectSlug}/vulnerabilities/${vulnerabilityId}/complete-vulnerability/`,
    fd,
    {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data.data as any;
};
